import React, { useState, useEffect } from "react"
import { useSelector } from "react-redux"
import { Link, useLocation } from "react-router-dom"
import { HamburgerMenu } from "../components"
import { getServices } from "../redux"
import "../style/Navbar.scss"

function Navbar() {
	const [displayMenu, setDisplayMenu] = useState(false)
	const services = useSelector(getServices)
	const serviceId = useLocation().pathname.slice(1)

	useEffect(() => {
		const handleScroll = () => {
			const menu = document.querySelector(".hamburgerButton")
			const navbar = document.querySelector(".navbar")

			if (!menu || !navbar) return

			if (window.pageYOffset >= window.innerHeight - 75) {
				menu.style.display = "none"
				navbar.style.position = "fixed"
				navbar.style.top = "0px"

				return setDisplayMenu(true)
			}

			menu.style.display = "block"
			navbar.style.position = "static"

			setDisplayMenu(false)
		}

		window.addEventListener("scroll", handleScroll)

		return () => window.removeEventListener("scroll", handleScroll)
	}, [])

	const navItemsList = services.map(s => (
		<Link
			className="navbar__item"
			to={`/${s.id}`}
			key={s.id}
			style={{ background: s.id === serviceId ? "#35bdf6" : undefined }}
		>
			{s.title}
		</Link>
	))

	return (
		<div className="navbar">
			{navItemsList}

			{displayMenu ? <HamburgerMenu /> : <></>}
		</div>
	)
}

export default Navbar
